var free_section_filters = ( function( $ ) {

	var $filters;

	var _init = function() {
		$filters = $( '.free-section-title .filters' );

		if ( $filters.length > 0 ) {
			_setup_filter_toggle();
		}
	};

	var _setup_filter_toggle = function() {
		$filters.closest( '.left' ).find( 'a.toggle-filters' ).on( 'click', function( e ) {
			e.preventDefault();
			_toggle_transition_class();
		} );

		$( '#content' ).on( 'click', function( e ) {
			if ( $filters.closest( '.left' ).hasClass( 'open' ) && ! e.target.matches( '#page-title-bar .left, #page-title-bar .left *' ) ) {
				_remove_transition_class();
			}
		} );
	};

	var _toggle_transition_class = function() {
		if ( $filters.closest( '.left' ).hasClass( 'open' ) ) {
			_remove_transition_class();
		} else {
			_add_transition_class();
		}
	};

	var _add_transition_class = function() {
		$filters.addClass( 'anim-in' );
		$filters.removeClass( 'out' );

		$filters.closest( '.left' ).addClass( 'open' );
	};

	var _remove_transition_class = function() {
		$filters.removeClass( 'anim-in' );
		$filters.closest( '.left' ).removeClass( 'open' );

		setTimeout( function() {
			$filters.addClass( 'out' );
		}, 200 );
	};

	$( document ).ready( _init );

	return {};

})( jQuery );

module.exports = free_section_filters;